import { React, useState, useEffect } from 'react';
import PageHeader from 'utility/PageHeader';
import PageBody from 'utility/PageBody';
import { Button, Form, Input, Row, Col, Table, Modal, Image, Select, Upload, DatePicker, Spin } from 'antd';
import { HttpHandler } from '../../shared/httpHandler';
import { EditOutlined, DeleteOutlined, RocketOutlined, PlusOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import dayjs from 'dayjs';
import secureStorage from '../../shared/secureStorage';

const httpHandler = new HttpHandler();

const sendingTargetOptionsMap = {
    '1': '全體好友',
    '2': '綁定會員',
    '3': '指定 UID',
}

const sendingTypeOptionsMap = {
    "push": "推播訊息",
    "pnp": "通知型訊息",
}

const BroadcastMaintenance = () => {
    const [msgSearchForm] = Form.useForm();
    const [msgEditForm] = Form.useForm();
    const [msgTableData, setMsgTableData] = useState([]);
    const [msgTableParams, setMsgTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [loading, setLoading] = useState(false);
    const [currentMsg, setCurrentMsg] = useState({});
    const [selectedMsg, setSelectedMsg] = useState({});
    const [currentEditType, setCurrentEditType] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [previewVisible, setPreviewVisible] = useState(false);
    const [apiLoading, setApiLoading] = useState(false);
    const [showUploadExcel, setShowUploadExcel] = useState(false);
    const [excelFileList, setExcelFileList] = useState([]);
    const handleTableChange = (pagination, filters, sorter) => {
        setMsgTableParams({
            pagination,
            filters,
            ...sorter,
        });
        getMsgData(pagination);
    };


    const searchMsgData = async () => {
        setMsgTableParams({
            ...msgTableData,
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
        getMsgData({
            current: 1,
            pageSize: 10,
        });
    }

    const getMsgData = async (pagination = msgTableParams.pagination) => {
        let { title, content, memo, sendingTarget, sendingTime, timeCondition, sendingType } = msgSearchForm.getFieldsValue();
        title = title ? title : '';
        content = content ? content : '';
        memo = memo ? memo : '';
        sendingTarget = sendingTarget ? sendingTarget : '';
        sendingTime = sendingTime && timeCondition ? `${timeCondition}${dayjs(sendingTime).format("YYYY-MM-DD HH:mm:ss")}` : '';
        sendingType = sendingType ? sendingType : '';
        const { current, pageSize } = pagination;
        // console.log('sendingTime:', sendingTime);

        setLoading(true);
        httpHandler.get(`/broadcast_maintenance/get_broadcast_msg?title=${title}&content=${content}&memo=${memo}&sending_target=${sendingTarget}&sending_time=${sendingTime}&current=${current}&page_size=${pageSize}`)
            .then((response) => {
                if (response.success) {
                    setMsgTableData(response.data);
                    setMsgTableParams({
                        ...msgTableData,
                        pagination: {
                            ...pagination,
                            total: response.total,
                        },
                    });
                } else {
                    window.antdNotify('錯誤', response.data.message, 'fail');
                }
                setLoading(false);
            });
    }

    const MsgSearchBar = () => {
        return (
            <Form form={msgSearchForm}
                name="msgSearchForm"
                onFinish={searchMsgData}
            >
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item label="標題" name="title">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="內容" name="content">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="備註" name="memo">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="發送對象" name="sendingTarget">
                            <Select allowClear>
                                <Select.Option value={1}>全體好友</Select.Option>
                                <Select.Option value={2}>綁定會員</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="發送類型" name="sendingType">
                            <Select allowClear>
                                <Select.Option value="push">推播訊息</Select.Option>
                                <Select.Option value="pnp">通知型訊息</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="時間條件"
                            name="timeCondition"
                            dependencies={['sendingTime']}
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value && getFieldValue('sendingTime')) {
                                            return Promise.reject(new Error('請選擇時間條件'));
                                        }
                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <Select allowClear>
                                <Select.Option value=">">晚於</Select.Option>
                                <Select.Option value="<">早於</Select.Option>
                                <Select.Option value="=">等於</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="發送時間"
                            name="sendingTime"
                            dependencies={['timeCondition']}
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value && getFieldValue('timeCondition')) {
                                            return Promise.reject(new Error('請選擇發送時間'));
                                        }
                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <DatePicker showTime allowClear format="YYYY-MM-DD HH:mm:ss" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={16} className="button-group">
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                setCurrentEditType("新增推播訊息");
                                setIsModalVisible(true);
                            }}
                            className="button button--register">
                            新增
                        </Button>
                        <Button
                            type="primary"
                            icon={<SearchOutlined />}
                            htmlType="submit"
                            className="button button--search">
                            搜尋
                        </Button>
                    </Col>
                </Row>
            </Form >
        )
    }

    // 上傳前檢查
    const beforeUpload = (file) => {
        // 檢查檔案類型

        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            window.antdNotify('錯誤', '只能上傳圖片檔案', 'fail');
            return Upload.LIST_IGNORE;
        }
        // 檢查檔案大小
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            window.antdNotify('錯誤', '圖片大小不能超過10MB', 'fail');
            return Upload.LIST_IGNORE;
        }
        return false;
    };
    // 上傳圖片轉base64
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };
    // 預覽圖片
    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewTitle(file.name);
        setPreviewImage(file.preview);
        setPreviewVisible(true);
    };

    const handleRemove = () => {
        setPreviewVisible(false)
        setPreviewImage('')
        setFileList([])
    }

    const MsgDataTable = () => {
        const columns = [
            {
                title: '編輯',
                key: 'editMsg',
                render: (text, record) => {
                    return (
                        <Button
                            type="primary"
                            icon={<EditOutlined />}
                            onClick={() => {
                                setSelectedMsg(record);
                                setCurrentEditType("編輯推播訊息");
                                msgEditForm.setFieldsValue({
                                    ...record,
                                    sending_time: dayjs(record.sending_time),
                                });
                                setIsModalVisible(true);
                            }}
                        >
                            編輯訊息
                        </Button>
                    );
                },
            },
            {
                title: '刪除',
                key: 'deleteMsg',
                render: (text, record) => {
                    const isDisabled = record.sending_result !== 'waiting'
                    return (
                        <Button
                            type="primary"
                            danger
                            icon={<DeleteOutlined />}
                            disabled={isDisabled}
                            onClick={() => {
                                Modal.confirm({
                                    title: '刪除訊息',
                                    content: `你確定要刪除這筆訊息嗎？`,
                                    okText: '確定',
                                    cancelText: '取消',
                                    onOk() {
                                        httpHandler.post('/broadcast_maintenance/cancel_broadcast_msg', {
                                            id: record.id,
                                            cancel_user: secureStorage.getItem('userName'),
                                        }).then((response) => {
                                            if (response.success) {
                                                window.antdNotify('成功', '刪除推播訊息成功', 'success');
                                                searchMsgData();
                                            } else {
                                                window.antdNotify('錯誤', response.message, 'fail');
                                            }
                                        });
                                    },
                                });
                            }}
                        >
                            刪除訊息
                        </Button>
                    );
                },
            },
            {
                title: "圖片",
                dataIndex: 'img',
                key: 'img',
                render: (text, record) => {
                    const { img, img_extension } = record;
                    if (img && img_extension) {
                        return <img src={`data:image/${img_extension};base64,${img}`} alt="配備圖片" style={{ width: '100px' }} />;
                    } else {
                        return '無圖片';
                    }
                },
            },
            {
                title: '圖片連結/路徑',
                dataIndex: 'img_url',
                key: 'img_url',
            },
            {
                title: '標題',
                dataIndex: 'title',
                key: 'title',
            },
            {
                title: '內容',
                dataIndex: 'content',
                key: 'content',
            },
            {
                title: '連結名稱 1',
                dataIndex: 'url1_name',
                key: 'url1_name',
            },
            {
                title: "訊息連結 1",
                dataIndex: 'content_url1',
                key: 'content_url1',
            },
            {
                title: '連結名稱 2',
                dataIndex: 'url2_name',
                key: 'url2_name',
            },
            {
                title: "訊息連結 2",
                dataIndex: 'content_url2',
                key: 'content_url2',
            },
            {
                title: '連結名稱 3',
                dataIndex: 'url3_name',
                key: 'url3_name',
            },
            {
                title: "訊息連結 3",
                dataIndex: 'content_url3',
                key: 'content_url3',
            },
            {
                title: '發送對象',
                dataIndex: 'sending_target',
                key: 'sending_target',
                render: (text) => {
                    return sendingTargetOptionsMap[text];
                }
            },
            {
                title: "發送類型",
                dataIndex: 'sending_type',
                key: 'sending_type',
                render: (text) => {
                    return sendingTypeOptionsMap[text];
                }
            },
            {
                title: '發送時間',
                dataIndex: 'sending_time',
                key: 'sending_time',
                render: (text) => {
                    return dayjs(text).format('YYYY-MM-DD HH:mm:ss');
                }
            },
            {
                title: "發送結果",
                dataIndex: 'sending_result',
                key: 'sending_result',
            },
            {
                title: '發送數量',
                dataIndex: 'sending_mount',
                key: 'sending_mount',
            },
            {
                title: '備註',
                dataIndex: 'memo',
                key: 'memo',
            },
            {
                title: '建立人員',
                dataIndex: 'create_user',
                key: 'create_user',
            },
            {
                title: '建立人員部門',
                dataIndex: 'create_user_dept',
                key: 'create_user_dept',
            }

        ]

        return (
            <div>
                <Table
                    columns={columns}
                    loading={loading}
                    dataSource={msgTableData}
                    pagination={msgTableParams.pagination}
                    scroll={{ x: 'max-content' }}
                    onChange={handleTableChange}
                />
            </div>
        );
    }

    const handleModalOnFinish = () => {
        searchMsgData()
        setIsModalVisible(false);
        setSelectedMsg({});
        setCurrentEditType("");
        setPreviewImage('');
        setPreviewTitle('');
        setPreviewVisible(false);
        setFileList([]);
        msgEditForm.resetFields();
    }

    const handleModalOnCancel = () => {
        setIsModalVisible(false);
        setSelectedMsg({});
        setCurrentEditType("");
        setPreviewImage('');
        setPreviewTitle('');
        setPreviewVisible(false);
        setFileList([]);
        msgEditForm.resetFields();
    }

    // const setSelectedMsgFieldsValue = (record) => {
    //     msgEditForm.setFieldsValue({
    //         title: record.title,
    //         content: record.content,
    //         content_url1: record.content_url1,
    //         content_url2: record.content_url2,
    //         content_url3: record.content_url3,
    //         img: record.img,
    //         memo: record.memo,
    //         sendingTarget: record.sending_target,
    //         sendingType: record.sending_type,
    //         sendingTime: dayjs(record.sending_time),
    //     });
    // }

    const EditModal = () => {

        const showConfirm = () => {
            const submitData = msgEditForm.validateFields()
                .then((values) => {
                    Modal.confirm({
                        title: `確認${currentEditType}`,
                        content: `你確定要儲存這些變更嗎？`,
                        okText: '確定',
                        cancelText: '取消',
                        onOk() {
                            editModalSubmitHandler();
                            setIsModalVisible(false);
                        },
                        onCancel() {
                            console.log('取消儲存');
                        },
                    });
                })
                .catch((errorInfo) => {
                    console.log('Validation failed:', errorInfo);
                    return null;
                });
            // console.log('submitData:', submitData);

        };

        const handleSelectChange = (value) => {
            setShowUploadExcel(value === 3); // 當選擇值為 3 時顯示上傳欄位
        };

        const handleUploadChange = ({ fileList }) => {
            setFileList(fileList);

            // 檢查文件是否上傳完成
            fileList.forEach(file => {
                handlePreview(file);
            });

        };

        const handelExcelUploadChange = ({ fileList }) => {
            setExcelFileList(fileList);
            // 檢查文件是否上傳完成
            fileList.forEach(file => {
                handlePreview(file);
            });
        }


        return (

            <Modal
                width="50%"
                title={`${currentEditType}`}
                visible={isModalVisible}
                onCancel={() => {
                    handleModalOnCancel();
                }}
                footer={[
                    <Button
                        key="close"
                        onClick={() => {
                            handleModalOnCancel();
                        }}
                    >
                        關閉
                    </Button>,
                    <Button
                        key="save"
                        type="primary"
                        onClick={() => {
                            showConfirm();
                        }}
                    >
                        儲存
                    </Button>,
                ]}
            >

                <Form
                    form={msgEditForm}
                    name="msgEditForm"
                >
                    <Form.Item label="訊息主題" name="title" rules={[{ required: true, message: '請輸入訊息主題' }]}>
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="訊息圖片" name="img">
                        {previewVisible && (
                            <Image
                                src={previewImage}
                                alt="Upload Image"
                                style={{
                                    // width: '100%',
                                    height: '100%',
                                }}
                            />
                        )}
                        <Upload
                            name="msgImg"
                            listType="picture"
                            fileList={fileList}
                            beforeUpload={beforeUpload}
                            onPreview={handlePreview}
                            onChange={handleUploadChange}
                            onRemove={handleRemove}
                        // showUploadList={false}
                        >
                            <Button icon={<UploadOutlined />}>上傳圖片</Button>
                        </Upload>
                    </Form.Item>
                    <Form.Item label="圖片連結/路徑" name="img_url">
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="訊息內容" name="content" rules={[{ required: true, message: '請輸入訊息內容' }]}>
                        <Input.TextArea allowClear rows={4} />
                    </Form.Item>
                    <Form.Item label="連結名稱1" name="url1_name">
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="訊息連結1" name="content_url1">
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="連結名稱2" name="url2_name">
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="訊息連結2" name="content_url2">
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="連結名稱3" name="url3_name">
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="訊息連結3" name="content_url3">
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item label="發送對象" name="sending_target" rules={[{ required: true, message: '請選擇發送對象' }]}>
                        <Select onChange={handleSelectChange}>
                            <Select.Option value={1}>全體好友</Select.Option>
                            <Select.Option value={2}>綁定會員</Select.Option>
                            <Select.Option value={3}>指定 UID</Select.Option>
                        </Select>
                    </Form.Item>
                    {showUploadExcel && (
                        <Form.Item
                            label="上傳 Excel 檔案"
                            name="excel_file"
                            rules={[{ required: true, message: '請上傳 Excel 檔案' }]}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Upload accept=".xlsx, .xls" maxCount={1} fileList={excelFileList} onChange={handelExcelUploadChange}>
                                    <Button icon={<UploadOutlined />}>點擊上傳</Button>
                                </Upload>
                                <Button
                                    type="link"
                                    onClick={() => {
                                        // 替換成範例檔案的實際下載連結
                                        window.open(`${process.env.REACT_APP_BASE_URL}/dashboard/broadcast_maintenance/get_broadcast_example`, '_blank');
                                    }}
                                >
                                    下載範例檔
                                </Button>
                            </div>
                        </Form.Item>
                    )}
                    <Form.Item label="發送類型" name="sending_type" rules={[{ required: true, message: '請選擇發送類型' }]}>
                        <Select>
                            <Select.Option value="push">推播訊息</Select.Option>
                            <Select.Option value="pnp">通知型訊息</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="發送時間" name="sending_time" rules={[{ required: true, message: '請選擇發送時間' }]}>
                        <DatePicker showTime allowClear />
                    </Form.Item>
                    <Form.Item label="訊息備註" name="memo">
                        <Input.TextArea allowClear rows={4} />
                    </Form.Item>
                </Form>


            </Modal>

        );
    };

    const editModalSubmitHandler = async () => {
        setApiLoading(true);
        // console.log('apiLoading', apiLoading);

        const submitData = msgEditForm.getFieldsValue();

        // console.log('submit_submitData:', submitData);


        if (currentEditType === "新增推播訊息") {

            let binaryData = "";
            let extension = "";

            if (fileList && fileList.length > 0) {
                try {
                    binaryData = await getBase64(submitData.img.fileList[0].originFileObj);
                    extension = submitData.img.fileList[0].name.split('.').pop();
                } catch (error) {
                    console.error('Error reading file:', error);
                }
            }

            if (submitData.sending_target === 3 && !excelFileList) {
                window.antdNotify('錯誤', '請上傳 UID Excel 檔案', 'fail');
                setApiLoading(false);
                return;
            }

            let excelBinaryData = "";
            let excelExtension = "";
            if (excelFileList && excelFileList.length > 0) {
                try {
                    excelBinaryData = await getBase64(excelFileList[0].originFileObj);
                    excelExtension = excelFileList[0].name.split('.').pop();
                } catch (error) {
                    console.error('Error reading file:', error);
                }
            }

            const postData = {
                "title": submitData.title,
                "content": submitData.content,
                "content_url1": submitData.content_url1 ? btoa(submitData.content_url1) : '',
                "content_url2": submitData.content_url2 ? btoa(submitData.content_url2) : '',
                "content_url3": submitData.content_url3 ? btoa(submitData.content_url3) : '',
                "img": binaryData,
                "img_extension": extension,
                "memo": submitData.memo ? submitData.memo : '',
                "sending_target": submitData.sending_target ? submitData.sending_target : '',
                "sending_type": submitData.sending_type,
                "sending_time": submitData.sending_time ? dayjs(submitData.sending_time).format("YYYY-MM-DD HH:mm:ss") : '',
                "create_user": secureStorage.getItem('userId'),
                "url1_name": submitData.url1_name ? submitData.url1_name : '',
                "url2_name": submitData.url2_name ? submitData.url2_name : '',
                "url3_name": submitData.url3_name ? submitData.url3_name : '',
                "img_url": submitData.img_url ? submitData.img_url : '',
                "create_user_dept": secureStorage.getItem('userDepartment'),
                "excel_file": excelBinaryData,
            }
            // console.log('postData:', postData);
            httpHandler.post('/broadcast_maintenance/insert_broadcast_msg', postData).then((response) => {
                if (response.success) {
                    window.antdNotify('成功', '新增推播訊息成功', 'success');
                    handleModalOnFinish();
                } else {
                    window.antdNotify('錯誤', response.message, 'fail');
                }
            }).finally(() => {
                setApiLoading(false);
            });
        } else if (currentEditType === "編輯推播訊息") {
            // console.log(`fileList: ${fileList}`);
            // console.log('submitData:', submitData);

            let binaryData = "";
            let extension = "";

            if (fileList && fileList.length > 0) {
                if (submitData.img && submitData.img.fileList.length > 0) {
                    try {
                        binaryData = await getBase64(submitData.img.fileList[0].originFileObj);
                        extension = submitData.img.fileList[0].name.split('.').pop();
                    } catch (error) {
                        console.error('Error reading file:', error);
                    }
                }
            }

            if (submitData.sending_target === 3 && !excelFileList) {
                window.antdNotify('錯誤', '請上傳 UID Excel 檔案', 'fail');
                setApiLoading(false);
                return;
            }

            let excelBinaryData = "";
            let excelExtension = "";
            if (excelFileList && excelFileList.length > 0) {
                try {
                    excelBinaryData = await getBase64(excelFileList[0].originFileObj);
                    excelExtension = excelFileList[0].name.split('.').pop();
                } catch (error) {
                    console.error('Error reading file:', error);
                }
            }


            const postData = {
                "id": selectedMsg.id,
                "title": submitData.title,
                "content": submitData.content,
                "content_url1": submitData.content_url1 ? btoa(submitData.content_url1) : '',
                "content_url2": submitData.content_url2 ? btoa(submitData.content_url2) : '',
                "content_url3": submitData.content_url3 ? btoa(submitData.content_url3) : '',
                "img": binaryData ? binaryData : selectedMsg.img,
                "img_extension": extension ? extension : selectedMsg.img_extension,
                "memo": submitData.memo ? submitData.memo : '',
                "sending_target": submitData.sending_target ? submitData.sending_target : '',
                "sending_type": submitData.sending_type,
                "sending_time": dayjs(submitData.sending_time).format("YYYY-MM-DD HH:mm:ss"),
                "sending_result": submitData.sending_result ? submitData.sending_result : '',
                "update_user": secureStorage.getItem('userId'),
                "url1_name": submitData.url1_name ? submitData.url1_name : '',
                "url2_name": submitData.url2_name ? submitData.url2_name : '',
                "url3_name": submitData.url3_name ? submitData.url3_name : '',
                "img_url": submitData.img_url ? submitData.img_url : '',
                "excel_file": excelBinaryData,
            }
            // console.log('postData:', postData);
            httpHandler.post('/broadcast_maintenance/update_broadcast_msg', postData).then((response) => {
                if (response.success) {
                    window.antdNotify('成功', '編輯推播訊息成功', 'success');
                    handleModalOnFinish();
                } else {
                    window.antdNotify('錯誤', response.message, 'fail');
                }
            }).finally(() => {
                setApiLoading(false);
                // console.log('apiLoading', apiLoading);
            });
        }

    }

    const section = [
        {
            hasTitle: false,
            title: 'Search',
            children: <MsgSearchBar />,
        },
        {
            hasTitle: false,
            title: 'Search',
            children: <MsgDataTable />,
        },
        {
            hasTitle: false,
            title: 'Edit and Modal',
            children: <EditModal loading={apiLoading} />,
        },
    ]

    useEffect(() => {
        getMsgData();
    }, []);

    return (
        <Spin spinning={apiLoading} tip="讀取中..." style={{ height: '100vh' }}>
            <PageHeader functionName={'lexus_broadcast'}></PageHeader>
            <PageBody section={section}></PageBody>
        </Spin>
    );
}

export default BroadcastMaintenance;